import React, { useState, useEffect } from "react";
import { useParams, Outlet, useNavigate, useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import Sidebar from "../components/SideBar";
import styles from "../styles/Layout.module.css";
import projectMenus from "./menu-items";
import ProjectFooter from "layouts/ProjectLayOut/ProjectFooter";
import { Box, Collapse, Drawer, List, ListItemButton, ListItemText, Tooltip, useMediaQuery } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { useCheckMenuPermission } from "hooks/useCheckMenuPermission";
import { useAuth } from "context/AuthContext";

const Layout = () => {
  const [open, setOpen] = useState(false);
  const { menu, "*": submenu } = useParams();
  const navigate = useNavigate();
  const [currentMenu, setCurrentMenu] = useState(null);
  const isMobile = useMediaQuery('(max-width:768px)');
  const { hasPermission } = useCheckMenuPermission();
  const [expandedMenus, setExpandedMenus] = useState({});
  const location = useLocation();
  const { user } = useAuth();

  const toHyphenatedLowerCase = (str) => {
    return str.split(" ").join("-").toLowerCase();
  };

  useEffect(() => {
    const formattedMenu = toHyphenatedLowerCase(menu);
    const selectedMenu = projectMenus?.topMenus?.find(
      (m) => toHyphenatedLowerCase(m?.menu) === formattedMenu
    );

    setCurrentMenu(selectedMenu || projectMenus?.topMenus[0]);

    if (selectedMenu && !submenu) {
      navigate(`/${formattedMenu}/${selectedMenu?.submenus[0]?.route}`);
    }
  }, [menu, submenu, navigate]);

  const handleDrawerClose = () => {
    setOpen(!open);
  }

  // Toggle submenu expansion
  const handleExpand = (menu) => {
    setExpandedMenus((prev) => {
      const newExpandedMenus = {};
      newExpandedMenus[menu] = !prev[menu]; // Toggle the selected menu
      return newExpandedMenus;
    });
    setOpen(true)
  };

  const handleClickAway = () => {
    if (open) {
      setOpen(false)
    }
  };

  return (
    <div className={styles.layout}>
      <Navbar menus={projectMenus?.topMenus} handleDrawer={handleDrawerClose} handleClickAway={handleClickAway} isOpen={open} />
      <div className={styles.main}>
        {isMobile ?
          <div className={styles.sidebar}>
            <Drawer
              variant="permanent" // or "persistent"/"temporary" for responsive behavior
              open={open}
              sx={{
                width: open ? 240 : 0,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                  width: open ? isMobile ? '100%' : 240 : 0,
                  boxSizing: 'border-box',
                  transition: 'width 0.3s ease',
                  marginTop: '63px',
                  backgroundColor: '#f3f3f3',
                  border: 0,
                  display: 'flex',
                  flexDirection: 'column',
                  height: 'calc(100vh - 63px)', // ensure it doesn't exceed the screen
                  overflow: 'hidden', // hide overflow except list
                },
              }}
            >
              <Box sx={{ overflowY: 'auto', flexGrow: 1 }}>
                <List
                  sx={{
                    paddingTop: 0
                  }}>
                  {projectMenus?.topMenus?.filter(item => {
                    const hasRoleAccess =
                      item?.rolesAllowed?.some(role => user?.rolesName?.includes(role));

                    if (item?.menu === "Projects") {
                      return true;
                    }
                    return hasRoleAccess;
                  })
                    ?.map((item) => {

                      const mainActiveMenu = (() => {
                        if (item.route === "") {
                          return false;
                          // return location.pathname === `/projects/${projectId}`;
                        } else {
                          if (item.route && item.route !== false) {
                            return location.pathname.endsWith(
                              `/${item.route}`
                            );
                          }
                          return false;
                        }
                      })();

                      return (
                        <React.Fragment key={item.menu}>
                          <ListItemButton
                            onClick={() => {
                              if (item.submenus?.length > 0) {
                                handleExpand(item.menu)
                              } else {
                                navigate(`/${item.route}`)
                                if (open) {
                                  setOpen(false)
                                }
                              }
                              // item.submenus
                              //   ? 
                              //   : 
                            }

                            }
                            sx={{
                              bgcolor: mainActiveMenu ? "#E8E8E8" : "inherit",
                              borderRadius: "4px",
                              justifyContent: open ? 'start' : 'center',
                              paddingLeft: open ? '26px' : '16px',
                              '& .MuiListItemIcon-root': {
                                justifyContent: open ? 'start' : 'center'
                              }
                            }}
                          >
                            <Tooltip
                              placement="right"
                              title={!open ? item.menu : ''}
                              arrow
                              slotProps={{
                                tooltip: { sx: { fontSize: "12px" } },
                              }}
                            >
                            </Tooltip>

                            {open && (
                              <ListItemText
                                primary={item.menu}
                                sx={{
                                  "& .MuiTypography-root": { fontSize: "16px" },
                                }}
                              />
                            )}
                            {item.submenus && open &&
                              (expandedMenus[item.menu] ? (
                                <ExpandLess />
                              ) : (
                                <ExpandMore />
                              ))}
                          </ListItemButton>
                          {item.submenus && open && (
                            <Collapse
                              in={expandedMenus[item.menu]}
                              timeout="auto"
                              unmountOnExit
                            >
                              <List component="div" disablePadding>
                                {item?.submenus
                                  ?.map((sub) => {
                                    const isActive = location.pathname.includes(
                                      `/${item?.route}/${sub?.route}`
                                    );

                                    return (
                                      <ListItemButton
                                        key={sub.route}
                                        sx={{
                                          pl: open ? 7 : 2,
                                          bgcolor: isActive ? "#e8e8e8" : "inherit",
                                          borderRadius: "4px",
                                          marginTop: "2px"
                                        }}
                                        onClick={() => {
                                          if (item.route) {
                                            navigate(`/${item?.route}/${sub?.route}`)
                                          }
                                          if (open) {
                                            setOpen(false)
                                          }
                                        }

                                        }
                                      >
                                        <ListItemText
                                          primary={sub.name}
                                          sx={{
                                            "& .MuiTypography-root": {
                                              fontSize: "16px",
                                              fontWeight: isActive ? "500" : "normal",
                                            },
                                          }}
                                        />
                                      </ListItemButton>
                                    );
                                  })}
                              </List>
                            </Collapse>
                          )}
                        </React.Fragment>
                      );
                    })}
                </List>
              </Box>

            </Drawer>
          </div>

          :
          <Sidebar menu={currentMenu} topMenus={projectMenus?.topMenus} />

        }


        <div className={styles.content} style={{
          display: open
            ? isMobile
              ? 'none'
              : 'flex'
            : 'flex', flexDirection: 'column', paddingLeft: isMobile && '10px', paddingRight: isMobile && '10px'
        }}>
          <div style={{ flex: 1 }}>
            <Outlet />
          </div>
          <ProjectFooter />
        </div>
      </div>
    </div>
  );
};

export default Layout;
